import { images } from ".";

export const gardenTherapyData = {
    title: "Ogrodoterapia",
    subtitle: "w Fundacji Dwór Imielno",
    // Sekcja Hero / Wstęp
    intro: {
        heading: "Natura, która leczy",
        description: "Ogrodoterapia to metoda wspierania zdrowia psychicznego i fizycznego poprzez kontakt z przyrodą i aktywności ogrodnicze. W naszym parku i ogrodzie historycznym w Imielnie wykorzystujemy tę formę terapii, aby łączyć dziedzictwo kulturowe, naturalne piękno ogrodu i naukowo potwierdzone korzyści dla człowieka."
    },
    // Sekcja Korzyści (4 kafelki)
    benefits: [
        {
            id: 1,
            title: "Redukcja Stresu",
            text: "Obniża poziom stresu i poprawia nastrój.",
            source: "(Kaplan & Kaplan, 1989)",
            icon: "fas fa-heart" // Przykładowa klasa ikony
        },
        {
            id: 2,
            title: "Rehabilitacja",
            text: "Wspomaga rehabilitację osób z problemami psychicznymi i neurologicznymi.",
            source: "(Sempik, Hine & Wilcox, 2010)",
            icon: "fas fa-walking"
        },
        {
            id: 3,
            title: "Funkcje Poznawcze",
            text: "Poprawia funkcje poznawcze u seniorów i osób z demencją.",
            source: "(Gonzalez et al., 2010)",
            icon: "fas fa-brain"
        },
        {
            id: 4,
            title: "Rozwój Społeczny",
            text: "Wspiera rozwój społeczny, motywację i poczucie sprawczości uczestników terapii grupowej.",
            source: "",
            icon: "fas fa-users"
        }
    ],
    // Sekcja Nasze Podejście (3 kolumny)
    approach: [
        {
            id: 1,
            title: "Zajęcia w ogrodzie",
            description: "Indywidualne i grupowe zajęcia – praca z roślinami, planowanie rabat, pielęgnacja i obserwacja przyrody.",
            images: images.gardenTheraphy_2
        },
        {
            id: 2,
            title: "Warsztaty edukacyjne",
            description: "Połączenie ogrodnictwa z wiedzą o bioróżnorodności, historii ogrodu i ochronie środowiska.",
            images: images.gardenTheraphy_3
        },
        {
            id: 3,
            title: "Programy terapeutyczne",
            description: "Dla seniorów i osób w kryzysie zdrowotnym – uwzględniające aspekty sensoryczne, motoryczne i psychologiczne.",
            images: images.gardenTheraphy_4
        }
    ],
    // Bibliografia
    bibliography: [
        "Kaplan, R., & Kaplan, S. (1989). The Experience of Nature: A Psychological Perspective. Cambridge University Press.",
        "Sempik, J., Hine, R., & Wilcox, D. (2010). Green Care: Concept, Evidence and Practice. Routledge.",
        "Gonzalez, M. T., Hartig, T., Patil, G. G., Martinsen, E. W., & Kirkevold, M. (2010). Therapeutic horticulture in clinical depression: a prospective study. Research on Aging, 32(4), 484–508.",
        "Clatworthy, J., Hinds, J., & Camic, P. M. (2013). Gardening as a mental health intervention: a review. Mental Health Review Journal, 18(4), 214–225."
    ],
    footerQuote: "Fundacja Dwór Imielno wierzy, że połączenie historii, natury i nauki pozwala stworzyć wyjątkową przestrzeń do zdrowienia, rozwoju i budowania relacji międzyludzkich."
};

export default gardenTherapyData;